import { takeLatest, put, all, call } from "redux-saga/effects";
import productsActionTypes from "./productsActionTypes";
import {
  getProductSuccess,
  getProductsFailed,
  getProductsGroupFailed,
  getProductsGroupSuccess,
  getProductsCategoryFailed,
  getProductsCategorySuccess,
  getBrandsFailed,
  getBrandsSuccess,
  getSuppliersFailed,
  getSuppliersSuccess,
} from "./productsActions";
import Server from "../../service/Server";
import {
  createRequestData,
  requestERPLYData,
  getResponseData,
  formartCompayTypes,
  partnerKey,
} from "../../utils";

export function* getAllProducts() {
  try {
    const products = yield call(Server.getProducts);
    if (products.err) {
      yield put(getProductsFailed(products.err));
    } else {
      yield put(getProductSuccess(products));
    }
  } catch (error) {
    yield put(getProductsFailed(error));
  }
}

export function* onGetProductsStart() {
  yield takeLatest(productsActionTypes.GET_ALL_PRODUCTS_START, getAllProducts);
}

export function* getAllGroups({ payload: { baseUrl, keys } }) {
  try {
    const groups = yield call(Server.getProductGroups, baseUrl, keys);
    if (groups.err) {
      yield put(getProductsGroupFailed(groups.err));
    } else {
      yield put(getProductsGroupSuccess(groups));
    }
  } catch (error) {
    yield put(getProductsGroupFailed(error));
  }
}

export function* onGetProductGroupsStart() {
  yield takeLatest(productsActionTypes.GET_PRODUCT_GROUPS_START, getAllGroups);
}

export function* getPriorityGroup({ payload: { baseUrl, keys } }) {
  try {
    const response = yield call(Server.getPriorityGroup, baseUrl, keys);
    yield put({
      type: productsActionTypes.GET_PRIORITY_GROUP_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_PRIORITY_GROUP_FAILED,
      payload: [],
    });
  }
}

export function* onGetPriorityStart() {
  yield takeLatest(
    productsActionTypes.GET_PRIORITY_GROUP_START,
    getPriorityGroup
  );
}

export function* getCountries({ payload: { baseUrl, keys } }) {
  try {
    const response = yield call(Server.getProductCountries, baseUrl, keys);
    yield put({
      type: productsActionTypes.GET_PRODUCT_COUNTRY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_PRODUCT_COUNTRY_FAILED,
      payload: [],
    });
  }
}

export function* onGetProductCountriesStart() {
  yield takeLatest(productsActionTypes.GET_PRODUCT_COUNTRY_START, getCountries);
}

export function* getAllCategory({ payload: { baseUrl, keys } }) {
  try {
    const categories = yield call(Server.getProductCategories, baseUrl, keys);
    if (categories.err) {
      yield put(getProductsCategoryFailed(categories.err));
    } else {
      yield put(getProductsCategorySuccess(categories));
    }
  } catch (error) {
    yield put(getProductsCategoryFailed(error));
  }
}

export function* onGetProductCategoryStart() {
  yield takeLatest(
    productsActionTypes.GET_PRODUCT_CATEGORY_START,
    getAllCategory
  );
}

export function* getBrands({ payload: { baseUrl, keys } }) {
  try {
    const brands = yield call(Server.getProductBrands, baseUrl, keys);
    if (brands.err) {
      yield put(getBrandsFailed(brands.err));
    } else {
      yield put(getBrandsSuccess(brands));
    }
  } catch (error) {
    yield put(getBrandsFailed(error));
  }
}

export function* onGetBrandsStart() {
  yield takeLatest(productsActionTypes.GET_BRANDS_START, getBrands);
}

export function* getSuppliers({ payload: { baseUrl, keys } }) {
  try {
    const suppliers = yield call(
      Server.getSuppliers,
      baseUrl,
      keys,
      null,
      false
    );
    yield put(getSuppliersSuccess(suppliers.data));
  } catch (error) {
    yield put(getSuppliersFailed([]));
  }
}

export function* onGetSuppliersStart() {
  yield takeLatest(productsActionTypes.GET_SUPPLIERS_START, getSuppliers);
}

export function* getAssortments({ payload: { baseUrl, keys } }) {
  try {
    const assortments = yield call(Server.getAssortments, baseUrl, keys);
    if (assortments.err) {
      yield put({
        type: productsActionTypes.GET_ASSORTMENTS_FAILED,
        payload: assortments.err,
      });
    } else {
      yield put({
        type: productsActionTypes.GET_ASSORTMENTS_SUCCESS,
        payload: assortments,
      });
    }
  } catch (error) {
    yield put(
      getSuppliersFailed({
        type: productsActionTypes.GET_ASSORTMENTS_FAILED,
        payload: error,
      })
    );
  }
}

export function* onGetAssortmentsStart() {
  yield takeLatest(productsActionTypes.GET_ASSORTMENTS_START, getAssortments);
}

export function* getProductTotalCount({ payload: { baseUrl, keys } }) {
  try {
    const count = yield call(Server.getProductCount, baseUrl, keys);
    console.log("count", count);

    if (count.err) {
      yield put({
        type: productsActionTypes.GET_PRODUCT_TOTAL_COUNT_FAILED,
        payload: count.err,
      });
    } else {
      yield put({
        type: productsActionTypes.GET_PRODUCT_TOTAL_COUNT_SUCCESS,
        payload: count.totalCount,
      });
    }
  } catch (error) {
    yield put(
      getSuppliersFailed({
        type: productsActionTypes.GET_PRODUCT_TOTAL_COUNT_FAILED,
        payload: error,
      })
    );
  }
}

export function* onGetProductTotalCountStart() {
  yield takeLatest(
    productsActionTypes.GET_PRODUCT_TOTAL_COUNT_START,
    getProductTotalCount
  );
}

export function* getProductGroupTotalCount({ payload: { baseUrl, keys } }) {
  try {
    const count = yield call(Server.getProductGroupCount, baseUrl, keys);
    console.log("count", count);

    if (count.err) {
      yield put({
        type: productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_FAILED,
        payload: count.err,
      });
    } else {
      yield put({
        type: productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_SUCCESS,
        payload: count.totalCount,
      });
    }
  } catch (error) {
    yield put(
      getSuppliersFailed({
        type: productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_FAILED,
        payload: error,
      })
    );
  }
}

export function* onGetProductGroupTotalStart() {
  yield takeLatest(
    productsActionTypes.GET_PRODUCT_GROUP_TOTAL_COUNT_START,
    getProductGroupTotalCount
  );
}

export function* getVatRates({ payload: { sessionKey, clientCode } }) {
  const request = {
    requests: createRequestData(20, {
      requestName: "getVatRates",
      recordsOnPage: 100,
      sendContentType: 1,
      orderByDir: "asc",
    }),
    clientCode,
    sessionKey,
  };

  try {
    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: productsActionTypes.GET_VAT_RATES_FAILED,
        payload: response.data.status,
      });
    } else {
      yield put({
        type: productsActionTypes.GET_VAT_RATES_SUCCESS,
        payload: getResponseData(response.data.requests),
      });
    }
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_VAT_RATES_FAILED,
      payload: error,
    });
  }
}

export function* onGetVatRateStart() {
  yield takeLatest(productsActionTypes.GET_VAT_RATES_START, getVatRates);
}

export function* getCompanyTypes({ payload: { sessionKey, clientCode } }) {
  try {
    const request = {
      sessionKey,
      clientCode,
      request: "getCompanyTypes",
      sendContentType: 1,
      partnerKey,
    };

    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: productsActionTypes.GET_COMPANY_TYPES_FAILED,
      });
    } else {
      yield put({
        type: productsActionTypes.GET_COMPANY_TYPES_SUCCESS,
        payload: formartCompayTypes(response.data.records),
      });
    }
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_COMPANY_TYPES_FAILED,
    });
  }
}

export function* onGetCompantTypeStart() {
  yield takeLatest(
    productsActionTypes.GET_COMPANY_TYPES_START,
    getCompanyTypes
  );
}

export function* getCurriences({ payload: { sessionKey, clientCode } }) {
  try {
    const request = {
      sessionKey,
      clientCode,
      request: "getCurrencies",
      sendContentType: 1,
      partnerKey,
    };

    const response = yield call(requestERPLYData, request);
    if (response.data.status.responseStatus === "error") {
      yield put({
        type: productsActionTypes.GET_CURRENCIES_FAILED,
      });
    } else {
      yield put({
        type: productsActionTypes.GET_CURRENCIES_SUCCESS,
        payload: response.data.records.map((e) => ({
          ...e,
          currencyID: parseInt(e.currencyID, 10),
        })),
      });
    }
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_CURRENCIES_FAILED,
    });
  }
}

export function* onGetCurrenciesStart() {
  yield takeLatest(productsActionTypes.GET_CURRENCIES_START, getCurriences);
}

export function* getSupplierTypes({ payload: { baseUrl, keys } }) {
  try {
    const types = yield call(Server.getSupplierTypes, baseUrl, keys);
    yield put({
      type: productsActionTypes.GET_SUPPLIER_TYPES_SUCCESS,
      payload: types.data,
    });
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_SUPPLIER_TYPES_FAILED,
    });
  }
}

export function* onGetSupplierTypeStart() {
  yield takeLatest(
    productsActionTypes.GET_SUPPLIER_TYPES_START,
    getSupplierTypes
  );
}

export function* getIndentedGroups({ payload: { baseUrl, keys } }) {
  try {
    const response = yield call(Server.getProductGroupsIndented, baseUrl, keys);
    console.log(response);
    yield put({
      type: productsActionTypes.GET_INDENTED_GROUPS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_INDENTED_GROUPS_FAILED,
    });
  }
}

export function* onGetIndentedGroupsStart() {
  yield takeLatest(
    productsActionTypes.GET_INDENTED_GROUPS_START,
    getIndentedGroups
  );
}

export function* getIndentedCategories({ payload: { baseUrl, keys } }) {
  try {
    const response = yield call(
      Server.getProductCategoryIndented,
      baseUrl,
      keys
    );
    yield put({
      type: productsActionTypes.GET_INDENTED_CATEGORY_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: productsActionTypes.GET_INDENTED_CATEGORY_FAILED,
    });
  }
}

export function* onGetIndentedCategoryStart() {
  yield takeLatest(
    productsActionTypes.GET_INDENTED_CATEGORY_START,
    getIndentedCategories
  );
}

export function* productSagas() {
  yield all([
    call(onGetProductsStart),
    call(onGetProductCategoryStart),
    call(onGetProductGroupsStart),
    call(onGetBrandsStart),
    call(onGetSuppliersStart),
    call(onGetAssortmentsStart),
    call(onGetProductTotalCountStart),
    call(onGetVatRateStart),
    call(onGetProductGroupTotalStart),
    call(onGetPriorityStart),
    call(onGetProductCountriesStart),
    call(onGetCompantTypeStart),
    call(onGetCurrenciesStart),
    call(onGetSupplierTypeStart),
    call(onGetIndentedGroupsStart),
    call(onGetIndentedCategoryStart),
  ]);
}
